/** @format */

import { Vue, Component } from 'vue-property-decorator';
import mixedUtils from '@root/common/mixins/list-page/utils.js';
@Component
export default class TableWidth extends Vue {
  // 表格列的配置描述
  get tableColums(): any[] {
    return [];
  }
  tableHeight = null;

  /**
   * 获取表格宽度
   */
  get tableWidth() {
    let width = 0;
    width = this.tableWidthChildren(this.tableColums);
    return width;
  }

  mounted() {
    var offsetTop = function(elem) {
      var top = elem.offsetTop;
      var parent = elem.offsetParent;
      while (parent) {
        top += parent.offsetTop;
        parent = parent.offsetParent;
      }
      return top;
    };
    // this.$nextTick(() => {

    //   mixedUtils.poll(

    //     () => '$el' in (this.$refs.paginationTable || {}),
    //     () => {
    //       this.tableHeight = document.documentElement.clientHeight - offsetTop(this.$refs.paginationTable.$el) - 100
    //     },
    //     () => {},
    //     20000,
    //     50,
    //   )

    // })
  }

  tableWidthChildren(tableColums: any): number {
    let width = 0;
    tableColums.forEach((element: any) => {
      if (element.children && element.children.length > 0) {
        width += this.tableWidthChildren(element.children);
      } else {
        width += Number(element.width) || 140;
      }
    });
    return width;
  }
}
